import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trend',
})
export class TrendPipe implements PipeTransform {
  transform(trend: number, emptySymbol = ''): string {
    if (trend === undefined || isNaN(trend)) return emptySymbol;
    if (trend === null) return emptySymbol;
    return trend ? `${Math.round(Math.abs(trend))}%` : emptySymbol;
  }
}
